import { NgModule } from '@angular/core';
import { AccountComponent } from './account.component';
import { AccountProfileBasicDataComponent } from './profile/basic-data/account.profile.basic-data.component';
import { AccountProfileComponent } from './profile/account.profile.component';
import { AccountSidebarComponent } from './sidebar/account.sidebar.component';
import { AccountProfileAddressesComponent } from './profile/addresses/account.profile.addresses.component';
import { AccountProfileContactComponent } from './profile/contact/account.profile.contact.component';
import { AccountCardsComponent } from './cards/account.cards.component';
import { AccountCardsItemComponent } from './cards/item/account.cards.item.component';
import { AccountCardsCreateComponent } from './cards/create/account.cards.create.component';
import { AccountProfileBasicDataPasswordComponent } from './profile/basic-data/password/account.profile.basic-data.password.component';
import { AccountProfileAddressesItemComponent } from './profile/addresses/item/account.profile.addresses.item.component';
import { AccountOrdersComponent } from './orders/account.orders.component';
import { AccountPointsComponent } from './points/account.points.component';
import { AccountPointsSummaryComponent } from './points/account.points-summary.component';
import { PointsService } from '../shared/services/points.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { StoreConfigurationsService } from '../shared/services/store-configurations.service';
import {
    TranslateLoader,
    TranslateModule,
    TranslateService
} from '@ngx-translate/core';
import { AppComponent } from '../app.component';
import { CookieService } from 'angular2-cookie/core';
import { BootstrapModalModule } from 'ngx-modialog/plugins/bootstrap';
import { HttpModule } from '@angular/http';
import { ResponsiveModule } from 'ng2-responsive';
import { CommonHttpService } from '../shared/services/http.service';
import { IdentificationStepsService } from '../payment/services/identification-steps.service';
import { NgxMaskModule } from 'ngx-mask';
import { HttpClientModule } from '@angular/common/http';
import { Angular2SocialLoginModule } from 'angular2-social-login';
import { PasswordRecoveryStepsService } from '../payment/services/password-recovery-steps.service';
import { ModalModule } from 'ngx-modialog';
import { ToastrModule } from 'ngx-toastr';
import { CustomFormsModule } from 'ng2-validation';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from '../app-routing.module';
import { UnauthenticatedUserRepositoryService } from '../payment/services/unauthenticated-user-repository.service';
import { OauthService } from '../shared/services/oauth.service';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { AuthenticatedUserRepositoryService } from '../payment/services/authenticated-user-repository.service';
import { LoaderModule } from '../shared/components/loader/loader.module';
import { AccountOrdersListItemComponent } from './orders/list/item/account.orders.list.item.component';
import { AccountOrdersDetailsComponent } from './orders/details/account.orders.details.component';
import { AccountOrdersDetailsBasicDataComponent } from './orders/details/basic-data/account.orders.details.basic-data.component';
import { AccountOrdersDetailsItemsComponent } from './orders/details/items/account.orders.details.items.component';
import { AccountOrdersDetailsShippingAddressComponent } from './orders/details/shipping-address/account.orders.details.shipping-address.component';
import { ThumbSourceFactoryService } from '../shared/services/thumb-source-factory.service';
import { TextMaskModule } from 'angular2-text-mask';
import { ObjKeysPipe } from '../shared/pipes/obj-keys.pipe';
import { AccountSubscriptionsListComponent } from './subscriptions/list/account.subscriptions.list.component';
import { AccountSubscriptionsDetailsComponent } from './subscriptions/details/account.subscriptions.details.component';
import { AccountSubscriptionsListItemComponent } from './subscriptions/list/item/account.subscriptions.list.item.component';
import { AccountSubscriptionsDetailsOrdersComponent } from './subscriptions/details/orders/account.subscriptions.details.orders.component';
import { AccountSubscriptionsDetailsBasicDataComponent } from './subscriptions/details/basic-data/account.subscriptions.details.basic-data.component';
import { AccountSubscriptionsDetailsActionsComponent } from './subscriptions/details/actions/account.subscriptions.details.actions.component';
import { AccountSubscriptionsDetailsPaymentDataComponent } from './subscriptions/details/payment-data/account.subscriptions.details.payment-data.component';
import { AccountSubscriptionsDetailsActionsPauseComponent } from './subscriptions/details/actions/pause/account.subscriptions.details.actions.pause.component';
import { AccountSubscriptionsDetailsActionsAutoRenewComponent } from './subscriptions/details/actions/auto-renew/account.subscriptions.details.actions.auto-renew.component';
import { AccountSubscriptionsDetailsActionsPaymentMethodComponent } from './subscriptions/details/actions/payment-method/account.subscriptions.details.actions.payment-method.component';
import { AccountSubscriptionsDetailsActionsPaymentMethodBankSlipComponent } from './subscriptions/details/actions/payment-method/bank-slip/account.subscriptions.details.actions.payment-method.bank-slip.component';
import { AccountSubscriptionsDetailsActionsPaymentMethodCardComponent } from './subscriptions/details/actions/payment-method/card/account.subscriptions.details.actions.payment-method.card.component';
import { AccountSubscriptionsDetailsActionsPaymentMethodNonTransparentCheckoutComponent } from './subscriptions/details/actions/payment-method/non-transparent-checkout/account.subscriptions.details.actions.payment-method.non-transparent-checkout.component';
import { AccountSubscriptionsDetailsActionsPaymentMethodPaymentOnShippingComponent } from './subscriptions/details/actions/payment-method/payment-on-shipping/account.subscriptions.details.actions.payment-method.payment-on-shipping.component';
import { CardInputsModule } from '../card-inputs/card-inputs.module';
import { CardsCreator } from './services/cards/creator';
import { WebpackTranslateLoader } from '../webpack-translate-loader';
import { AccountOrdersDetailsItemsItemComponent } from './orders/details/items/item/account.orders.details.items.item.component';
import { AccountOrdersDetailsItemsItemExtraFieldsComponent } from './orders/details/items/item/extra-fields/account.orders.details.items.item.extra-fields.component';
import { AccountOrdersDetailsItemsExtraFieldsComponent } from './orders/details/items/extra-fields/account.orders.details.items.extra-fields.component';
import { AccountOrdersDetailsItemsComponentsComponent } from './orders/details/items/components/account.orders.details.items.components.component';
import { AccountOrdersDetailsActionsComponent } from './orders/details/actions/account.orders.details.actions.component';
import { AccountOrdersDetailsActionsScheduleComponent } from './orders/details/actions/schedule/account.orders.details.actions.schedule.component';
import { MyDatePickerModule } from 'mydatepicker';
import { ClipboardModule } from 'ngx-clipboard/dist';
import { TranslationConfiguratorService } from '../shared/services/translation-configurator.service';
import { LocaleProvider } from '../shared/services/locale.service';
import { AccountSubscriptionsDetailsActionsCancelComponent } from './subscriptions/details/actions/cancel/account.subscriptions.details.actions.cancel.component';
import { AccountProfileExtraFieldsComponent } from './profile/extra-fields/account.profile.extra-fields.component';
import { AccountProfileExtraFieldsExtraFieldComponent } from './profile/extra-fields/extra-field/account.profile.extra-fields.extra-field.component';
import { AccountSubscriptionsDetailsPlanDetailsComponent } from './subscriptions/details/plan-details/account.subscriptions.details.plan-details.component';
import { AccountSubscriptionsDetailsPlanDetailsCurrentCycleComponent } from './subscriptions/details/plan-details/current-cycle/account.subscriptions.details.plan-details.current-cycle.component';
import { AppsService } from '../shared/services/apps.service';
import { AccountSubscriptionsDetailsActionsPaymentMethodPixComponent } from './subscriptions/details/actions/payment-method/pix/account.subscriptions.details.actions.payment-method.pix.component';
import { AccountCardsUpdateSubscriptionComponent } from './cards/update-subscription/account.cards.update-subscription.component';
import { AccountSubscriptionsDetailsActionsAddressComponent } from './subscriptions/details/actions/address/account.subscriptions.details.actions.address.component';
import { AccountFilesComponent } from './files/account.files.component';
import { AccountFilesService } from '../shared/services/account-files.service';

@NgModule({
    declarations: [
        AccountComponent,
        AccountSidebarComponent,
        AccountProfileComponent,
        AccountProfileBasicDataComponent,
        AccountProfileBasicDataPasswordComponent,
        AccountProfileContactComponent,
        AccountProfileAddressesComponent,
        AccountProfileAddressesItemComponent,
        AccountProfileExtraFieldsComponent,
        AccountProfileExtraFieldsExtraFieldComponent,
        AccountFilesComponent,
        AccountCardsComponent,
        AccountCardsItemComponent,
        AccountCardsCreateComponent,
        AccountCardsUpdateSubscriptionComponent,
        AccountOrdersComponent,
        AccountPointsComponent,
        AccountPointsSummaryComponent,
        AccountOrdersListItemComponent,
        AccountOrdersDetailsComponent,
        AccountOrdersDetailsBasicDataComponent,
        AccountOrdersDetailsItemsComponent,
        AccountOrdersDetailsItemsItemComponent,
        AccountOrdersDetailsItemsItemExtraFieldsComponent,
        AccountOrdersDetailsItemsExtraFieldsComponent,
        AccountOrdersDetailsItemsComponentsComponent,
        AccountOrdersDetailsShippingAddressComponent,
        AccountOrdersDetailsActionsComponent,
        AccountOrdersDetailsActionsScheduleComponent,
        AccountSubscriptionsListComponent,
        AccountSubscriptionsListItemComponent,
        AccountSubscriptionsDetailsComponent,
        AccountSubscriptionsDetailsOrdersComponent,
        AccountSubscriptionsDetailsBasicDataComponent,
        AccountSubscriptionsDetailsPaymentDataComponent,
        AccountSubscriptionsDetailsActionsComponent,
        AccountSubscriptionsDetailsActionsPauseComponent,
        AccountSubscriptionsDetailsActionsCancelComponent,
        AccountSubscriptionsDetailsActionsAutoRenewComponent,
        AccountSubscriptionsDetailsActionsPaymentMethodComponent,
        AccountSubscriptionsDetailsActionsPaymentMethodBankSlipComponent,
        AccountSubscriptionsDetailsActionsPaymentMethodCardComponent,
        AccountSubscriptionsDetailsActionsPaymentMethodNonTransparentCheckoutComponent,
        AccountSubscriptionsDetailsActionsPaymentMethodPaymentOnShippingComponent,
        AccountSubscriptionsDetailsActionsPaymentMethodPixComponent,
        AccountSubscriptionsDetailsActionsAddressComponent,
        AccountSubscriptionsDetailsPlanDetailsComponent,
        AccountSubscriptionsDetailsPlanDetailsCurrentCycleComponent,
        ObjKeysPipe
    ],
    imports: [
        LoaderModule,
        BrowserModule,
        CommonModule,
        HttpModule,
        HttpClientModule,
        FormsModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: WebpackTranslateLoader
            }
        }),
        Angular2SocialLoginModule,
        ReactiveFormsModule,
        NgxMaskModule,
        AppRoutingModule,
        CustomFormsModule,
        ResponsiveModule,
        ModalModule.forRoot(),
        BootstrapModalModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot({
            timeOut: 10000,
            positionClass: 'toast-top-full-width',
            preventDuplicates: true
        }),
        TextMaskModule,
        CardInputsModule,
        MyDatePickerModule,
        ClipboardModule
    ],
    providers: [
        CookieService,
        CommonHttpService,
        OauthService,
        ThumbSourceFactoryService,
        StoreConfigurationsService,
        AppsService,
        IdentificationStepsService,
        AuthenticatedUserRepositoryService,
        UnauthenticatedUserRepositoryService,
        PasswordRecoveryStepsService,
        CardsCreator,
        PointsService,
        AccountFilesService,
        LocaleProvider
    ],
    bootstrap: [
        AppComponent
    ],
    exports: [
        TranslateModule
    ]
})
export class AccountModule {

    constructor(
        public translate: TranslateService
    ) {
        translate.use(
            TranslationConfiguratorService.decideUseLanguage(this.translate.getBrowserLang())
        );
    }

}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/account/account.module.ts